import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

const loader = lazyForPaint(() => import(/* webpackChunkName: 'view-topic' */ './topic'));
export const ViewTopic = withAsync({
    loader,
});
